export default {
  //header
  'Services': "Services",
  'Expertise': "Expertise",
  'Industries': 'Industries',
  'Our team': 'Our team',
  'Our Projects': 'Our Projects',



  ///Expertise
  'Who we are': 'Who we are',

  'Who we are Text1': "JaiyqDev is a global technology partner leading change in transforming industries and generating long-lasting value for businesses, people, and the global community. ",
  'Who we are Text2': "They trust us with finding solutions to the toughest challenges and breaking constraints on their way to meaningful innovation in a dynamic market environment. ",
  'Who we are Text3': "Based on 20 years of market experience, JaiqDev people-centric approach and passion for client success unite engineers, creators, and innovators across Europe, North America, and the Middle East.",

  'Engineers Text1': "Engineers",
  'Engineers Text2': "in-house",

  'Expertise/Countries Text1': "Countries where",
  'Expertise/Countries Text2': "client are located",

  'Expertise/Experience Text1': "Years of ",
  'Expertise/Experience Text2': "experience",

  'Expertise/Senior Text1': "Senior",
  'Expertise/Senior Text2': "engineers",

  'Expertise/Our missions Text1': "Our missions",
  'Expertise/Our missions Text2': "We breath life into great ideas with",
  'Expertise/Our missions Text3': "the power of digital technology",



  ///Information
  "Information/Text1": "Smart Comfort in all",
  "Information/Text2": "the JaiyqDev's offices",
  "Information/Text3": "JaiyqDev is a global technology partner that enables the sustained success of top-tier organizations and Fortune 500 companies.",
  "Information/Text4": "By delivering value to our partners and clients with the power of technology, we inspire confidence that their digital initiatives will succeed. They trust us with finding solutions to the toughest challenges and breaking constraints on their way to meaningful innovation in a dynamic market environment.",



  ///CompanyStaff
  "CompanyStaff/Text1": "Meet our team",


  ///OurProjects
  "OurProjects/Text1": "Our Projects",

  ///Project
  "Project/Summary": "Summary:",
  "Project/Client": "Client",
  "Project/Country": "Country",
  "Project/Industry": "Industry",
  "Project/Type of service": "Type of service",
  "Project/What we've challenged to do": "What we've challenged to do",
  "Project/What we've done": "What we've done",
  "Project/What we've delivered": "What we've delivered",
  "Project/Stacks used": "Stacks used",
  "Project/Resources used": "Resources used",
  "Project/delivered app for iOS": "delivered app for iOS",
  "Project/delivered app for android": "delivered app for android",



  ///Footersec
  "Footersec/You find us": "You find us",
  "Footersec/Visit": "Visit",
  "Footersec/Oral kalasy, Eskalieva 179": "Oral kalasy, Eskalieva 179",


  ///Projects
  //id 1
  "Projects/projectId1WhatOurClientDo": "Shipper service delivers purchases from foreign online stores to your door",
  "Projects/projectId1Country": "USA/Kazakhstan",
  "Projects/projectId1Industry": "Shopping, delivery",
  "Projects/projectId1TypeOfService": "Outsource",
  "Projects/projectId1WhatChallengedToDoMainText": "Our task was to create an application for IOS and Android and Web where user can:",
  "Projects/projectId1WhatChallengedToDoList1": "- create parcel",
  "Projects/projectId1WhatChallengedToDoList2": "- check parcel details, checkpoints",
  "Projects/projectId1WhatChallengedToDoList3": "- add balance with card payment, apple pay",
  "Projects/projectId1WhatDoneMainText": "The process was as follows:",
  "Projects/projectId1WhatDoneList1": "1. Analysis of the project scope, preparation of a plan for development",
  "Projects/projectId1WhatDoneList2": "2. Determining the team members responsibilities",
  "Projects/projectId1WhatDoneList3": "3. Implementation of design",
  "Projects/projectId1WhatDoneList4": "4. Multiplatform app launch",
  "Projects/projectId1WhatDeliveredMainText": "Workshops, building a roadmap (2 weeks). Building MVP (3.5 months). Collecting feedback from first clients, vendors and Shipper back office team (2 months). Further product development based on collected data. The app is easy to use and delivers a fast, smooth experience across mobile and tablet devices. Thanks to our work, Shipper users can search for parcels they need, see details of checkpoints, and add balance using card/Apple pay.",
  "Projects/projectId1StacksUsed": "Mobile App Development, Web Development, React Native, React, Redux-toolkit, REST API, Firebase, Push notifications, Deep linking, Payment with card, Apple pay, CloudPayments",
  "Projects/projectId1ResourcesUsed": "2 Mobile developers, 1 Project Manager, 1 Manual tester, 1 Web/Mobile designer",
  "Projects/projectId1Duration": "7+ months",

  //id 2
  "Projects/projectId2WhatOurClientDo": "Crypto, trading, social network for traders",
  "Projects/projectId2Country": "USA",
  "Projects/projectId2Industry": "Crypto, trading",
  "Projects/projectId2TypeOfService": "Outstaff",
  "Projects/projectId2WhatChallengedToDoMainText": "Earnity already had a fully functional web application. Due to market changes and users’ needs, the client sought to add a mobile app to the stack, both for Android and iOS platforms. As current users were familiar with the web app, the major challenge of the project was to deliver the same features and experience on the mobile version. The proposed app should be fast, scalable, and efficiently integrate with the API provided by the client. The client came to us with the final design and functional requirements but did not have much experience in the software development process.",
  "Projects/projectId2WhatDoneMainText": "The process was as follows:",
  "Projects/projectId2WhatDoneList1": "1. Analysis of project scope, preparation of a plan for development and design",
  "Projects/projectId2WhatDoneList2": "2. Determining the team members responsibilities",
  "Projects/projectId2WhatDoneList3": "3. Implementation of design",
  "Projects/projectId2WhatDoneList4": "4. Starting developement process",
  "Projects/projectId2WhatDeliveredMainText": "After launching Earnity here are most interesting features in our opinion:",
  "Projects/projectId2WhatDeliveredList1": "- user id verification using Jumio SDK",
  "Projects/projectId2WhatDeliveredList2": "- payment of tokens using Stripe payment system",
  "Projects/projectId2WhatDeliveredList3": "- social network, activity feeds and chat apps using GetStream.io",
  "Projects/projectId2WhatDeliveredList4": "- push notifications",
  "Projects/projectId2StacksUsed": "Mobile App Development, React Native, React Sweet state, getstream.io, Jumio SDK, Stripe SDK",
  "Projects/projectId2ResourcesUsed": "1 React Native developer",
  "Projects/projectId2Duration": "11+ months",

  //id 3
  "Projects/projectId3WhatOurClientDo": "The application is designed for pregnant women and mothers of children under the age of one year.",
  "Projects/projectId3Country": "Kazakhstan",
  "Projects/projectId3Industry": "Medical",
  "Projects/projectId3TypeOfService": "Outsource",
  "Projects/projectId3WhatChallengedToDoMainText": "Our task was to create an application for Android and iOS where user can:",
  "Projects/projectId3WhatChallengedToDoList1": "- have a online chat/video call with their attached doctor from clinic.",
  "Projects/projectId3WhatChallengedToDoList2": "- social network where user can share their knowledge and post some interesting news",
  "Projects/projectId3WhatChallengedToDoList3": "- health test",
  "Projects/projectId3WhatDoneMainText": "The process was as follows:",
  "Projects/projectId3WhatDoneList1": "1. Analysis of project scope, preparation of a plan for development and design",
  "Projects/projectId3WhatDoneList2": "2. Determining the team members responsibilities",
  "Projects/projectId3WhatDoneList3": "3. Implementation of design",
  "Projects/projectId3WhatDoneList4": "4. Starting developement process",
  "Projects/projectId3WhatDeliveredMainText": "Over the course of eight months, we created Supermom Academy - a cross-platform application that easily can call alarm for ambulance. The user can have a chat/video call with avaialble doctor. Thanks to the application, user can read posts and share, like, comment them.",
  "Projects/projectId3StacksUsed": "Mobile App Development, React Native",
  "Projects/projectId3ResourcesUsed": "1 Mobile developer, 1 Tester, 1 Project Manager, 1 Backend developer",
  "Projects/projectId3Duration": "8 months",

  //id 4
  "Projects/projectId4WhatOurClientDo": "Solutions for business: Online checkout, QR payments, delivery to parcel terminals, etc.",
  "Projects/projectId4Country": "Kazakhstan",
  "Projects/projectId4Industry": "Business",
  "Projects/projectId4TypeOfService": "Outstaff",
  "Projects/projectId4WhatChallengedToDoMainText": "Our task was to create an application for Android and iOS which acts as cash register, where business can: make payments, return payments, QR payments, print receipts via bluetooth device, check payment history and etc.",
  "Projects/projectId4WhatDeliveredMainText": "On the outcome we have mobile cash register. Business can easily accept payment, return payment if needed, print out receipts via external bluetooth printer, generate daily/weekly/monthly reports.",
  "Projects/projectId4StacksUsed": "Mobile App Development using React Native, Typescript, Redux tollkit, REST API, Firebase, Push notifications, Deep linking",
  "Projects/projectId4ResourcesUsed": "1 React Native developer",
  "Projects/projectId4Duration": "18+ months",

  //id 5
  "Projects/projectId5WhatOurClientDo": "Culdesac is a sports social media app designed to give the fans their voice back.",
  "Projects/projectId5Country": "USA",
  "Projects/projectId5Industry": "Sports",
  "Projects/projectId5TypeOfService": "Outstaff",
  "Projects/projectId5WhatChallengedToDoMainText": "The main task was to make app like reddit, where users can publish posts on sports events, debate on other posts, comments, agrees and disagrees with posts.",
  "Projects/projectId5WhatDeliveredMainText": "On the outcome we have mobile app for journalists, ex-athlete or just average fan. Users can like, comment, agree, disagree with posts. Most liked posts appear in populars list.",
  "Projects/projectId5StacksUsed": "Mobile App Development using React Native, Typescript, Redux tollkit, REST API, Firebase, Push notifications, Deep linking",
  "Projects/projectId5ResourcesUsed": "1 React Native developer",
  "Projects/projectId5Duration": "5 months",

  //id 6
  "Projects/projectId6WhatOurClientDo": "Highly curated benefits program designed to improve the life of the busy executive.",
  "Projects/projectId6Country": "USA",
  "Projects/projectId6Industry": "Business",
  "Projects/projectId6TypeOfService": "Outstaff",
  "Projects/projectId6WhatChallengedToDoMainText": "The task was to create an iOS/Android app where users can use a variety of benefits.",
  "Projects/projectId6WhatDeliveredMainText": "After launching the app, EXEC users can unlock access to heightened levels of hospitality and negotiated pricing through an exclusive collection of hundreds of benefits. EXEC helps people upgrade their life in ways that were previously unattainable.",
  "Projects/projectId6StacksUsed": "Mobile App Development using React Native, Typescript, Redux Toolkit, GraphQL, Firebase, Push Notifications, Deep Linking",
  "Projects/projectId6ResourcesUsed": "1 React Native developer",
  "Projects/projectId6Duration": "6-8 months",

  //id 7
  "Projects/projectId7WhatOurClientDo": "Membership-based luxury brand that designs, styles, and delivers the world's highest quality menswear and accessories.",
  "Projects/projectId7Country": "USA",
  "Projects/projectId7Industry": "Fashion Design",
  "Projects/projectId7TypeOfService": "Outstaff",
  "Projects/projectId7WhatChallengedToDoMainText": "The main challenge of the app was to implement an animated design requested by the client. Another task was to notify the user at every step of the collection delivery.",
  "Projects/projectId7WhatDeliveredMainText": "The outcome was a beautiful cross-platform app. Users can save their credit cards in the app, choose the default one, and make payments for membership.",
  "Projects/projectId7StacksUsed": "Mobile App Development using React Native, Typescript, Redux Toolkit, REST API, Firebase, Push Notifications, Deep Linking",
  "Projects/projectId7ResourcesUsed": "1 React Native developer",
  "Projects/projectId7Duration": "8+ months",
}